/** @type {import('node_modules/vue-router/types/index').RouteConfig[]} */
import i18n from '@/i18n/i18n'

export const ANALYTICS_SHIPPING_ROUTE = 'analytics-shipping'

export default [
  // redirects users to the main analytics url in case they bookmarked the old one
  {
    name: 'analytics-new',
    path: '/analytics-new',
    redirect: { name: ANALYTICS_SHIPPING_ROUTE },
    children: [
      {
        name: 'analytics-new-shipping',
        path: '/analytics-new/shipping',
        redirect: { name: ANALYTICS_SHIPPING_ROUTE },
        meta: {
          pageTitle: () => i18n.t('Analytics'),
          permissions: ['view_analytics'],
        },
      },
    ],
  },
  {
    name: 'analytics',
    path: '/analytics',
    redirect: { name: ANALYTICS_SHIPPING_ROUTE },
    component: () => import('@/app/analytics/views/AnalyticsView.vue'),
    children: [
      {
        name: ANALYTICS_SHIPPING_ROUTE,
        path: '/analytics/shipping',
        component: () => import('@/app/analytics/shipments/views/AnalyticsShipmentsListView.vue'),
        meta: {
          pageTitle: () => i18n.t('Analytics'),
          permissions: ['view_analytics'],
        },
      },
    ],
    meta: {
      pageTitle: () => i18n.t('Analytics'),
    },
  },
]
